import { Component } from '@angular/core';

@Component({
  selector: 'kiosk-home',
  styles: [require('./kiosk-home.component.scss')],
  template: require('./kiosk-home.component.html'),
  preserveWhitespaces: false,
})
export class KioskHomeComponent {
  constructor() {};
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/kiosk/kiosk-home/kiosk-home.component.ts